import React, { ReactNode, useState } from "react";
import { TimerContext } from "../../../context/TimerContext";

interface IProps {
    children: ReactNode;
}

export function TimerContainer({ children }: IProps) {
    const [ time, setTime ] = useState<[number, number, number]>([0, 0, 0]);
    return (
        <TimerContext.Provider value={{ time, setTime }}>
            {children}
        </TimerContext.Provider>
    )
}
